import { KeyValueObject } from "../types/general";
import { getColorVariable } from "../utils/helper";
import { type InlineMessageProps } from "./inline-message";

export function getBackgroundColor(type: InlineMessageProps["type"], color: InlineMessageProps["color"], theme: any): KeyValueObject {
    if (color) {
        return {
            backgroundColor: getColorVariable(color, theme, {
                gray: theme.colors.gray[100],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][200],
                default: theme.colors.gray[950],
            }),
        };
    }
    if (type === "error") {
        return { backgroundColor: theme.colors.red[200] };
    }
    if (type === "warning") {
        return { backgroundColor: theme.colors.orange[200] };
    }
    if (type === "info") {
        return { backgroundColor: theme.colors.blue[200] };
    }
    if (type === "success") {
        return { backgroundColor: theme.colors.green[200] };
    }
    return {
        backgroundColor: getColorVariable(color, theme, {
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][200],
            default: theme.colors.gray[950],
        }),
    };
}

export function getColor(type: InlineMessageProps["type"], color: InlineMessageProps["color"], theme: any): KeyValueObject {
    if (color) {
        return {
            color: getColorVariable(color, theme, {
                white: theme.colors.gray[600],
                colorize: theme.colors[color || "primary"][600],
                default: theme.colors.white,
            }),
        };
    }
    if (type === "error") {
        return { color: theme.colors.red[600] };
    }
    if (type === "warning") {
        return { color: theme.colors.orange[600] };
    }
    if (type === "info") {
        return { color: theme.colors.blue[600] };
    }
    if (type === "success") {
        return { color: theme.colors.green[600] };
    }
    return {
        color: getColorVariable(color, theme, {
            white: theme.colors.gray[600],
            colorize: theme.colors[color || "primary"][600],
            default: theme.colors.white,
        }),
    };
}
